/**
 * Các thông điệp hiển thị trong giao diện Trợ lý AI
 */
export const AI_MESSAGES = {
  QUIZ_EMPTY_IMPORT: 'Không có câu hỏi nào để import.',
  /**
   * Thông báo khi import câu hỏi thành công nhưng chỉ lưu vào kho.
   */
  QUIZ_IMPORT_SUCCESS: (count: number) => `Đã thêm ${count} câu hỏi vào kho bài tập.`,
  /**
   * Thông báo khi bộ câu hỏi vừa được mở lên bảng và vẫn được lưu vào kho.
   * Đây là luồng mặc định sau khi áp dụng kết quả từ AI Quiz Supporter.
   */
  QUIZ_IMPORT_ON_BOARD: (count: number) => `Đã mở ${count} câu hỏi lên bảng và lưu vào kho bài tập.`,
  /** Thông báo khi mở câu hỏi đã lưu từ kho bài tập lên bảng. */
  QUIZ_OPENED_ON_BOARD: (count: number) => `Đã mở ${count} câu hỏi lên bảng.`,
  /** Kho bài tập từ chối lưu bộ câu hỏi - mạng hỏng hoặc máy chủ trả lỗi. */
  QUIZ_SAVE_FAILED: 'Không lưu được câu hỏi vào kho bài tập. Thầy/cô thử lại.',
  /** Kho bài tập mở từ trang riêng, chưa có tiết dạy nào để mở bảng. */
  QUIZ_NO_BOARD: 'Thầy/cô mở một tiết dạy trước, rồi mở lại bộ câu hỏi lên bảng.',
} as const;

/**
 * Tiền tố và khóa lưu trữ cục bộ (localStorage)
 */
export const AI_STORAGE_KEYS = {
  CHAT_ID_PREFIX: 'ai-quiz-chat-id',
  CHAT_ID_GUEST: 'ai-quiz-chat-id-guest',
} as const;

/**
 * Bộ chọn CSS cho các phần tử có thể nhận focus trong hộp thoại (focus trap)
 */
export const DIALOG_FOCUSABLE_SELECTOR =
  'button:not([disabled]), a[href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), summary, [tabindex]:not([tabindex="-1"])';
